import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'
import { Error } from 'components'
import { changeTheme } from 'utils'

changeTheme('LIGHT')

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/npss/combination'
        render={(routeProps) => require('./Combination').default(routeProps)}
      />
      <Route
        path='/npss/hint'
        render={(routeProps) => require('./Hint').default(routeProps)}
      />
      <Route
        path='/npss/result'
        render={(routeProps) => require('./Result').default(routeProps)}
      />
      <Route path='*'>
        <PageLayout>
          <Error type='404' />
        </PageLayout>
      </Route>
    </Switch>
  )
}

export default AppRouter
